import React from 'react';
import { AppBar, Toolbar } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';

const Extension = () => {
  const location = useLocation();
  const { extensionInstalled } = useSelector(state => state.api);
  const isDesktop = useMediaQuery({
    query: '(min-width: 1224px)',
  });
  const [isHovered, setIsHovered] = React.useState(false);

  const openExtensionPage = () => {
    window.open(
      'https://chrome.google.com/webstore/detail/trends/malnhaodjdegcljjebmpopbjmckblndn',
      '_blank'
    );
  };

  if (extensionInstalled) return null;

  const label = isDesktop
    ? location.pathname === '/kr'
      ? '브라우저에 확장 프로그램을 설치하세요'
      : 'Install the Ai bookmark on your browser'
    : location.pathname === '/kr'
      ? '현재 PC 크롬에서 이용 가능하세요!'
      : 'Now available on PC Chrome!';

  return (
    <AppBar
      position="fixed"
      elevation={0}
      style={{
        top: 'auto',
        bottom: 0,
        backgroundColor: 'transparent',
        boxShadow: 'none',
        flexGrow: 1,
        alignItems: 'center',
        paddingBottom: 16,
      }}
    >
      <Toolbar>
        <div style={{ textAlign: 'center', width: '100%' }}>
          <button
            type="button"
            onClick={openExtensionPage}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={{
              cursor: 'pointer',
              fontSize: '18px',
              border: '1px solid rgba(15, 23, 42, 0.12)',
              padding: '12px 18px',
              minHeight: '56px',
              lineHeight: 1.2,
              borderRadius: '14px',
              backgroundColor: isHovered ? '#f8fafc' : '#ffffff',
              color: '#0f172a',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 600,
              letterSpacing: '0.01em',
              boxShadow: isHovered
                ? '0 12px 26px rgba(15, 23, 42, 0.11)'
                : '0 10px 24px rgba(15, 23, 42, 0.08)',
              transition:
                'background-color 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease',
              outline: 'none',
              appearance: 'none',
              WebkitAppearance: 'none',
            }}
          >
            <img
              src="img/chrome.svg"
              alt="chrome extension logo"
              style={{ width: 30, height: 30, paddingRight: 10 }}
            />
            {label}
          </button>
        </div>
      </Toolbar>
    </AppBar>
  );
};

export default Extension;
